import { useNavigate } from 'react-router-dom'
import { CalendarIcon } from '@chakra-ui/icons'
import { HStack } from '@chakra-ui/react'
import { useDisplayModal, useEngine, usePin, useVehicles } from 'context'
import { sendMessageToApp } from 'services/connectToApp'
import { primaryColor } from 'theme/foundations/primaryColor'

import ButtonBox from 'components/ButtonBox'
import { CardContainer } from 'components/CustomCard'
import CustomDivider from 'components/CustomDivider'
import { CustomModal } from 'components/CustomModal'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CarIcon, LockedLogoIcon, UnlockedLogoIcon } from 'components/SVGS'

import VehicleCarrousel from './VehicleCarousel'

const { icon: { logoIconColor } } = primaryColor

const VehicleCard = () => {
  const navigate = useNavigate()
  const { engineState: { state: { engineBlocked } } } = useEngine()
  const { pinState: { state: { isHavePin } } } = usePin()
  const { vehicleState: { state: { vehicle } } } = useVehicles()
  const { closeModal, openDialog } = useDisplayModal()


  const handleLock = () => {
    !isHavePin ?
      openDialog({
        content: (
          <CustomModal
            title={`¡No es posible ${engineBlocked ? 'desbloquear' : 'bloquear'} el motor de tu vehículo!`}
            message='Crea tu PIN para poder bloquear y desbloquear el motor de tu vehículo'
            primaryButton
            primaryTextButton=' Ir a Crear PIN'
            closeAcceptPress={() => {
              closeModal()
              navigate('/create-pin')
            }}
            closeGoBackPress={() => closeModal()}
          />
        ),
        variant: 'primary'
      })
      :
      navigate('/confirm-to-pin', {
        state: {
          params: {
            text: `Ingresa tu PIN para ${engineBlocked ? 'desbloquear' : 'bloquear'
              } el motor de tu vehículo`,
            textButton: `${engineBlocked ? 'Desbloquear' : 'Bloquear'} motor`,
            previousRoute: 'HOME',
          },
        }
      })
  }

  const handleCall = () => {
    window.location.href = 'tel:*2400'
  }
  const handleOpenWorkshopReservations = () => {
    // window.location.href = 'https://reservas.kaufmann.cl/wbpindex'
    sendMessageToApp({ route:'workshop-reservations', link:'https://reservas.kaufmann.cl/wbpindex' })
  }

  return (
    <CardContainer paddingX={0} w={{ base: 'full', xl: '40%' }} h={{ base: 'full' }}>
      <VehicleCarrousel />
      <CustomDivider />
      <HStack spacing={2} px={2} wrap="wrap" justify="center" gap={2}>
        <ButtonBox
          disabled={!(vehicle?.isPremium)}
          icon={engineBlocked ? LockedLogoIcon : UnlockedLogoIcon}
          fill={logoIconColor}
          onClick={() => handleLock()}>
          {engineBlocked ? 'Desbloquear Motor' : 'Bloquear Motor'}
        </ButtonBox>
        <ButtonBox
          disabled={false}
          icon={CarIcon}
          onClick={() => handleCall()}
          >
          Asistencia Llamar *2400
        </ButtonBox>
        <ButtonBox
          disabled={false}
          icon={CalendarIcon}
          onClick={() => handleOpenWorkshopReservations()}
          >
          Taller Reservas
        </ButtonBox>
      </HStack>
    </CardContainer>
  )
}

export default VehicleCard
